import { Injectable, signal } from '@angular/core';

/** Estado del BusinessShell: drawer del sidebar en celular/tablet angosta. */
@Injectable({ providedIn: 'root' })
export class ShellService {
  readonly drawerOpen = signal(false);

  // region toggleDrawer
  toggleDrawer(): void { this.drawerOpen.update(v => !v); }

  // region closeDrawer
  closeDrawer(): void { this.drawerOpen.set(false); }
}
